import React from 'react';
import { Wifi, RefreshCw } from 'lucide-react';

interface ConnectionErrorProps {
  onRetry?: () => void;
  message?: string;
}

const ConnectionError: React.FC<ConnectionErrorProps> = ({ 
  onRetry, 
  message = "Unable to connect to the server. Please check your internet connection and try again."
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-md w-full transform transition-all duration-500 hover:shadow-2xl">
        {/* Error header with gradient background */}
        <div className="p-6 bg-gradient-to-r from-blue-500 to-blue-600">
          <div className="flex justify-center">
            <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center">
              <Wifi className="h-8 w-8 text-blue-500" />
            </div>
          </div>
          <h2 className="mt-4 text-center text-2xl font-bold text-white">Connection Error</h2>
        </div>
        
        {/* Error details */}
        <div className="p-6">
          <div className="mb-6">
            <div className="text-center text-gray-600 mb-4">
              {message}
            </div>
            
            {/* Error code display */}
            <div className="bg-gray-100 rounded-lg p-3 font-mono text-sm text-center text-gray-700">
              Error Code: NETWORK_ERROR
            </div>
          </div>
          
          {/* Action buttons */}
          <div className="flex flex-col space-y-3">
            <button
              onClick={onRetry || (() => window.location.reload())}
              className="w-full py-3 bg-blue-500 text-white rounded-lg font-medium transition hover:bg-blue-600 flex items-center justify-center space-x-2"
            >
              <RefreshCw className="h-5 w-5" />
              <span>Retry Connection</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectionError;